import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import { Box } from "@mui/material"
import { FC, memo, ReactNode } from "react"

export const SortableItem: FC<{
  id: string | number
  children: Function | ReactNode
}> = memo(({ id, children }) => {
  const {
    isDragging,
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({
    id,
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.7 : 1,
  }

  return (
    <Box component={"div"} ref={setNodeRef} style={style} {...attributes}>
      {typeof children === "function" ? children({ listeners }) : children}
    </Box>
  )
})
